/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireAnswerOption } from './CustomQuestionnaireAnswerOption';
import {
  CustomQuestionnaireAnswerOptionFromJSON,
  CustomQuestionnaireAnswerOptionFromJSONTyped,
  CustomQuestionnaireAnswerOptionToJSON,
} from './CustomQuestionnaireAnswerOption';

/**
 *
 * @export
 * @interface CustomQuestionnaireMultiSelectAnswerRead
 */
export interface CustomQuestionnaireMultiSelectAnswerRead {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireMultiSelectAnswerRead
   */
  id?: number;
  /**
   *
   * @type {Array<CustomQuestionnaireAnswerOption>}
   * @memberof CustomQuestionnaireMultiSelectAnswerRead
   */
  value: Array<CustomQuestionnaireAnswerOption>;
}

/**
 * Check if a given object implements the CustomQuestionnaireMultiSelectAnswerRead interface.
 */
export function instanceOfCustomQuestionnaireMultiSelectAnswerRead(
  value: object,
): value is CustomQuestionnaireMultiSelectAnswerRead {
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireMultiSelectAnswerReadFromJSON(json: any): CustomQuestionnaireMultiSelectAnswerRead {
  return CustomQuestionnaireMultiSelectAnswerReadFromJSONTyped(json, false);
}

export function CustomQuestionnaireMultiSelectAnswerReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireMultiSelectAnswerRead {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    value: (json['value'] as Array<any>).map(CustomQuestionnaireAnswerOptionFromJSON),
  };
}

export function CustomQuestionnaireMultiSelectAnswerReadToJSON(
  value?: CustomQuestionnaireMultiSelectAnswerRead | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    value: (value['value'] as Array<any>).map(CustomQuestionnaireAnswerOptionToJSON),
  };
}
